<template>
  <div class="ai-result flex flex-col p-4">
    <div class="ai-result__text p-4 bg-inactive-bg rounded-lg">
      <pre
        v-if="aiGeneratedText.length"
        class="text-sm text-text-default"
        >{{ aiGeneratedText }}</pre
      >

      <div
        v-else
        class="loading"
      ></div>
      <div
        v-if="aiGenericLinks.length"
        class="ai-sources flex items-center mt-3 flex-wrap"
      >
        <span class="text-text-placeholder text-xs mt-1">{{ translate('sources') }}</span>
        <SearchAiSourceItem
          v-for="source in aiGenericLinks"
          :key="source.id"
          :item="source"
          @hide-popup="hidePopup"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import SearchAiSourceItem from '@/components/widgets/SearchAiSourceItem.vue';

defineProps<{
  aiGeneratedText: string;
  aiGenericLinks: any[];
}>();

const emit = defineEmits(['hide-search-popup']);

const translate = (key: string): string => {
  return key;
};

onMounted(() => {
  window.addEventListener('keydown', checkKey);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', checkKey);
});

const checkKey = (event: KeyboardEvent): void => {
  if (event.key === 'Escape') {
    hidePopup();
  }
};

const hidePopup = (): void => {
  emit('hide-search-popup');
};
</script>

<style lang="scss">
.ai-result {
  .loading::after {
    font-weight: 900;
    content: ' .';
    animation: animated-dots 1s steps(5, end) infinite;
  }

  .ai-result__text {
    pre {
      font-family: 'Roboto', sans-serif;
      white-space: pre-wrap;
      user-select: text;
      cursor: default;
    }
  }
}
</style>
